import clsx from "clsx";

/**
 * Shared loading / empty primitives for rendering the non-success
 * states of a data fetch. Deliberately minimal — sized for inline form
 * controls. Phase 2 scales them to page level.
 */

type StateProps = {
  label: string;
  className?: string;
};

export function LoadingState({ label, className }: StateProps) {
  return (
    <div
      role="status"
      className={clsx(
        "flex items-center gap-2 text-sm text-zinc-500",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="size-3 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-500"
      />
      {label}
    </div>
  );
}

export function EmptyState({ label, className }: StateProps) {
  return (
    <div className={clsx("text-sm text-zinc-500 italic", className)}>
      {label}
    </div>
  );
}
